export default __webpack_public_path__ + "static/media/TON_symbol_nobg.da23b6f1.svg";